let controller = new AbortController()

export const getSessionAbortSignal = (): AbortSignal => controller.signal

export const abortSessionRequests = (): void => {
  controller.abort()
  controller = new AbortController()
}
